import { Box, Button, Card, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import ModalTestModel from "./ModalTestModel.jsx";
import SearchBar from "../SearchBar.jsx";
import ImportNewModelButton from "./ImportNewModelButton.jsx";
import modelTasks from "../../constants/modelTasks.json";
import ModelCard from "./ModelCard.jsx";
import useCurrentUser from "../../hooks/useCurrentUser";
// import ModelZooSelector from './ModelZooSelector.jsx'

const allModelsButton = { label: "All Models", value: "All", color: "#16a4b0" };
const filterButtons = [allModelsButton, ...modelTasks];

const ModelZoo = () => {
  const { permissions } = useCurrentUser();
  const [searchParams] = useSearchParams();
  const selectedApplication = searchParams.get("application") || "";
  const [filterTask, setfilterTask] = useState("All");
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [openTestModelDialog, setOpenTestModelDialog] = useState(null);
  const [zooType, setZooType] = useState("Public Model Zoo");

  const [models, setModels] = useState([]);

  // const fetchModels = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:8000/models/");
  //     setModels(response.data);
  //     console.log("Fetched all models:", response.data);
  //   } catch (error) {
  //     console.error("Error fetching models:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchModels();
  // }, []);

  const fetchModels = async (zooType) => {
    try {
      let url = "/models/";

      // If viewing private zoo, fetch only user’s models
      if (zooType === "Private Model Zoo") {
        url = "/models/me";
      }

      const response = await axios.get(url); // include credentials if needed
      setModels(response.data);
      console.log(`Fetched ${zooType} models:`, response.data);
    } catch (error) {
      console.error("Error fetching models:", error);
    }
  };

  // fetch once on mount, but only if zooType doesn't change immediately
  useEffect(() => {
    fetchModels(zooType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // refetch whenever zooType changes
  useEffect(() => {
    fetchModels(zooType);
  }, [zooType]);

  const handleOpenTestModelDialog = (index) => {
    setOpenTestModelDialog(index);
  };

  const handleCloseTestModelDialog = () => {
    setOpenTestModelDialog(null);
    setSelectedImage(null);
    setPreviewURL(null);
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const zooFilteredModels = models.filter((m) =>
    zooType === "Public Model Zoo"
      ? m.in_model_zoo_public
      : m.in_model_zoo_private,
  );

  // Derived: apply task filter + search filter
  const filteredModels = zooFilteredModels
    .filter(
      (model) =>
        !selectedApplication || model.info?.application === selectedApplication,
    )
    .filter((model) => {
      if (filterTask !== "All") {
        return model.info?.modelTask === filterTask;
      }
      return true;
    })
    .filter((model) => {
      const lowerSearch = searchText.toLowerCase();
      return (
        model.name?.toLowerCase().includes(lowerSearch) ||
        model.info?.description?.toLowerCase().includes(lowerSearch) ||
        model.info?.modelTask?.toLowerCase().includes(lowerSearch) ||
        model.info?.modelFramework?.toLowerCase().includes(lowerSearch)
      );
    });

  return (
    <Box
      sx={{
        mx: "auto",
        mt: 1,
        position: "relative",
        borderRadius: 4,
        overflow: "hidden",
        width: { xs: "80%", sm: "70%" },
        display: "flex",
        flexDirection: "column",
        p: 1,
      }}
    >
      {/* <Typography variant="h3" fontWeight={700} color="black" mt={4}>
            Model Zoo
        </Typography> */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 6, mt: 2 }}>
        <Typography variant="h3" fontWeight={700} color="black" mt={2}>
          Model Zoo
        </Typography>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, mt: 2 }}
        >
          {/* <ModelZooSelector value={zooType} onChange={setZooType} /> */}
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, mt: 2 }}>
        <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
          Explore pre-trained models for object counting, anomaly detection or
          pose estimation.
        </Typography>
        {/* <Box sx={{ ml: 'auto', transform: 'scale(1.2)', transformOrigin: 'right' }}>
            <ImportNewModelButton refreshModels={fetchModels} />
            </Box> */}
        {/* {zooType === "Public Model Zoo" &&
          permissions.includes("import_model") && (
            <Box
              sx={{
                ml: "auto",
                transform: "scale(1.2)",
                transformOrigin: "right",
              }}
            >
              <ImportNewModelButton
                refreshModels={() => fetchModels(zooType)}
              />
            </Box>
          )} */}
      </Box>

      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 2 }}>
            <ModelZooSelector value={zooType} onChange={setZooType} />
        </Box> */}

      <Box mt={4} sx={{ width: "100%" }}>
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          placeholder="Search models"
        />
      </Box>

      <Box sx={{ mt: 4, display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          {filterButtons.map((btn) => (
            <Button
              key={btn.value}
              onClick={() => setfilterTask(btn.value)}
              variant={filterTask === btn.value ? "contained" : "outlined"}
              sx={{
                borderRadius: "12px",
                borderColor: "#cccccc",
                color: filterTask === btn.value ? "white" : "black",
                backgroundColor:
                  filterTask === btn.value ? btn.color : "transparent",
                textTransform: "none",
                fontSize: "16px",
              }}
            >
              {btn.label}
            </Button>
          ))}
        </Box>
      </Box>

      {/* <Typography variant="h4" fontWeight={700} color="black" mt={4}>
            Available Models
        </Typography> */}
      {/* <Typography variant="h4" fontWeight={700} color="black" mt={4}>
          {zooType === "Public Model Zoo" ? "Public Models" : "Private Models"}
        </Typography> */}

      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          borderRadius: 2,
          p: 2,
        }}
      >
        {filteredModels.length === 0 ? (
          <Typography variant="body1" color="text.secondary">
            No models found matching your search.
          </Typography>
        ) : (
          filteredModels.map((model, index) => (
            <ModelCard
              key={index}
              model={model}
              expanded={expandedIndex === index}
              onToggleExpand={() => toggleExpand(index)}
              onTest={() => handleOpenTestModelDialog(index)}
            />
          ))
        )}
      </Box>

      {openTestModelDialog !== null && (
        <ModalTestModel
          open={openTestModelDialog !== null}
          model={filteredModels[openTestModelDialog]}
          onClose={handleCloseTestModelDialog}
          testImage={selectedImage}
          setTestImage={setSelectedImage}
          previewURL={previewURL}
          setPreviewURL={setPreviewURL}
        />
      )}
    </Box>
  );
};

export default ModelZoo;
